/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Edit_LinkInputs */



/**
* | output |
* | --- |
* | "Edit link" |
*
* @param {Community_Edit_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_edit_link = /** @type {((inputs?: Community_Edit_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Edit_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica link")
	return /** @type {LocalizedString} */ ("Edit link")
});